<template>
  <v-app v-if="!initializing">
    <v-main>
      <router-view />
    </v-main>
  </v-app>
  <v-app v-else>
    <v-main class="d-flex align-center justify-center" style="min-height: 100vh;">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
          width="6"
        ></v-progress-circular>
        <p class="text-h6 mt-4 text-grey">Cargando VVMonE...</p>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import notificationService from '@/services/notificationService'
import eventBus from '@/utils/eventBus'

export default {
  name: 'App',
  data() {
    return {
      initializing: true,
    }
  },
  async mounted() {
    // Inicializar la aplicación
    await this.initializeApp()
    
    // ✅ Inicializar sistema de notificaciones
    await this.initializeNotifications()
  },
  methods: {
    async initializeApp() {
      try {
        // Restaurar estado si existe token
        const token = localStorage.getItem('token')
        if (token) {
          await this.$store.dispatch('restoreState')
        }
      } catch (error) {
        console.error('Error al inicializar app:', error)
      } finally {
        // Ocultar loading después de 500ms mínimo
        setTimeout(() => {
          this.initializing = false
        }, 500)
      }
    },

    /**
     * ✅ Inicializar sistema de notificaciones
     */
    async initializeNotifications() {
      try {
        // Solo si el usuario está autenticado
        const token = localStorage.getItem('token')
        if (!token) {
          console.log('ℹ️ Usuario no autenticado, notificaciones no inicializadas')
          return
        }

        console.log('🔔 Inicializando sistema de notificaciones...')

        // 1. Inicializar el servicio (registra SW)
        await notificationService.initialize()

        // 2. Configurar listener para notificaciones en primer plano
        this.setupForegroundListener()

        console.log('✅ Sistema de notificaciones inicializado')
      } catch (error) {
        console.error('❌ Error inicializando notificaciones:', error)
      }
    },

    /**
     * ✅ Configurar listener de notificaciones en primer plano
     */
    setupForegroundListener() {
      notificationService.setupForegroundListener((payload) => {
        console.log('📩 Nueva notificación en primer plano:', payload)
        
        // 1. Mostrar toast
        if (this.$toast) {
          this.$toast.fire({
            icon: 'info',
            title: payload.notification?.title || 'Nueva notificación',
            text: payload.notification?.body || '',
            timer: 5000,
            timerProgressBar: true,
            showConfirmButton: false,
            position: 'top-end'
          })
        }

        // 2. ✅ Emitir evento usando eventBus (en lugar de $root.$emit)
        eventBus.emit('nueva-notificacion', payload)

        // 3. Reproducir sonido (opcional)
        this.playNotificationSound()
      })
    },

    /**
     * ✅ Reproducir sonido de notificación
     */
    playNotificationSound() {
      try {
        // Crear un beep simple
        const audioContext = new (window.AudioContext || window.webkitAudioContext)()
        const oscillator = audioContext.createOscillator()
        const gainNode = audioContext.createGain()
        
        oscillator.connect(gainNode)
        gainNode.connect(audioContext.destination)
        
        oscillator.frequency.value = 800
        oscillator.type = 'sine'
        
        gainNode.gain.setValueAtTime(0.3, audioContext.currentTime)
        gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5)
        
        oscillator.start(audioContext.currentTime)
        oscillator.stop(audioContext.currentTime + 0.5)
      } catch (error) {
        console.log('ℹ️ No se pudo reproducir sonido:', error)
      }
    }
  },
  
  /**
   * ✅ Limpiar al destruir el componente
   */
  beforeUnmount() {
    // Limpiar listeners de eventBus
    eventBus.all.clear()
  }
}
</script>

<style>
  * {
    font-family: 'Poppins', sans-serif;
  }

  body {
    margin: 0;
    padding: 0;
  }

  /* Estilo global para elementos bloqueados */
  .item-bloqueado {
    opacity: 0.4 !important;
    pointer-events: none !important;
    cursor: not-allowed !important;
  }

  .item-bloqueado * {
    cursor: not-allowed !important;
  }

  /* Banner de expiración en top del sidebar */
  .sidebar-expired-banner {
    background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
    color: white;
    padding: 12px;
    text-align: center;
    font-weight: bold;
    font-size: 0.875rem;
  }
</style>